import { render, staticRenderFns } from "./AppScoresSoccer.vue?vue&type=template&id=4f65c0f0&"
import script from "./AppScoresSoccer.vue?vue&type=script&lang=js&"
export * from "./AppScoresSoccer.vue?vue&type=script&lang=js&"
import style0 from "./AppScoresSoccer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports